import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-navy-light py-20 px-4 border-y border-white/5" data-id="element-64" data-mp="4uqcgsut9wrq">
      <div className="max-w-4xl mx-auto" data-id="element-65" data-mp="9ucs18y43p3p">
        <div className="bg-navy border border-gold/30 p-8 md:p-12 rounded-2xl flex flex-col md:flex-row items-center gap-8" data-id="element-66" data-mp="9tbhr6ox76n1">
          <div className="flex-shrink-0" data-id="element-67" data-mp="eur0ut7jf32s">
            <ShieldCheck className="w-24 h-24 text-gold" data-id="element-68" data-mp="jt29x1q0d9jy" />
          </div>
          <div className="text-center md:text-left" data-id="element-69" data-mp="jqpsqqs2r37y">
            <h2 className="text-2xl md:text-3xl font-headline font-bold text-white uppercase mb-4" data-id="element-70" data-mp="nst83qhv6ryi">
              Garantía de Hierro — 7 Días
            </h2>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-71" data-mp="xjnv4x2xpvl0">
              Si al leer este manual sientes que no te da una ventaja injusta
              sobre los otros padres, o si sientes que no es la ruta más clara
              que has visto para el futuro de tu hijo, escríbeme en los primeros{' '}
              <span className="text-gold font-bold" data-id="element-72" data-mp="25rnf6olk22o0">7 días</span> y te devuelvo
              cada centavo.
            </p>
            <p className="text-white font-bold uppercase tracking-wider" data-id="element-73" data-mp="20rsrsv0znv7p">
              Sin preguntas. Riesgo cero.
            </p>
          </div>
        </div>
      </div>
    </section>;
}